import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { selectIsFetching } from '../../../features/modal/modalSlice';
import { selectedNewPackageTitleData, selectPackageTabs, setPackageInfo } from '../../../features/package/packageSlice';
import { showToast } from '../../../toastify/Toast';
import Loading from '../../ui/Loading';
import { useInitializePackageForm } from '../../../hooks/packages/useInitializePackageForm';
import { useSavePackage } from '../../../hooks/packages/useSavePackage';
import NewPackageProduct from '../../layout/Admin/packages/NewPackageProduct';
import NewPackageData from '../../layout/Admin/packages/NewPackageData';
import PackageModalTab from '../../layout/Admin/packages/PackageModalTabs';
import PackageModalHeader from '../../layout/Admin/packages/PackageModalHeader';

interface NewPackageProps {
    typOfAction: 'newPackage' | 'updatePackage'
}

export default function NewPackage({ typOfAction }: NewPackageProps) {

    const dispatch = useDispatch();
    const newPackageTitleData = useSelector(selectedNewPackageTitleData);
    const isFetching = useSelector(selectIsFetching);
    const selectedTab = useSelector(selectPackageTabs);
    const { isErrorPackageItems, isLoadingPackageItems, isErrorCreatePackage, isErrorCreateNewPackageItems, } = useSavePackage({typOfAction})
    const isCurrentlyFetching = isLoadingPackageItems || isFetching;
    const { isLoadingPackageData, isErrorPackageData, errorMessagePackageData } = useInitializePackageForm({ typOfAction });

    useEffect(() => {
        if (isErrorCreatePackage) {
            const errMsg = "Failed to create package.";
            showToast(errMsg, "error");
        }

        if (isErrorCreateNewPackageItems) {
            const errMsg = "Failed to add package items.";
            showToast(errMsg, "error");
        }
    }, [isErrorCreatePackage, isErrorCreateNewPackageItems]);

    useEffect(() => {
        dispatch(
        setPackageInfo({
            packageName: newPackageTitleData.packageName,
            packageDescription: newPackageTitleData.description,
            packageBudget: newPackageTitleData.totalValue,
        })
        );
    }, [newPackageTitleData, dispatch]);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]">
            <div className='relative w-[90vw] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75vw] lg:w-[70vw] xl:w-[65vw]'>
                <div className={`flex flex-col w-full h-[80vh] flex-1 overflow-hidden py-5 space-y-2`}>
                    {isLoadingPackageData ? (
                        <Loading setH='h-full' message='Loading..'/>
                    ) : isErrorPackageData ? (
                        <div className='w-full h-full flex justify-center items-center'>
                            <p className='text-[14px]'>{errorMessagePackageData}</p>
                        </div>
                    ) : (
                        <>
                            <div className=" bg-white">
                                <PackageModalHeader typOfAction={typOfAction} />
                                <PackageModalTab />
                            </div>
                            { isCurrentlyFetching ? (
                                <Loading />
                            ) : isErrorPackageItems ? (
                                <div className='w-full h-full flex justify-center items-center'>
                                    <p className='text-[14px]'>Error. Please reload the page</p>
                                </div>
                            ) : (
                                <>
                                    {selectedTab === 'package' && (
                                        <NewPackageData typOfAction={typOfAction} />
                                    )}
                                    {selectedTab === 'product' && (
                                        <NewPackageProduct />
                                    )}
                                </>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
